import { Container, Navbar } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { Button } from "flowbite-react";
import Logo from '../../assets/images/admin-logo.svg'
import avtar from '../../assets/images/profile-placeholder.png'
import saferstoplogo from '../../assets/images/Logo - White BG without Hands.png'
import { useDispatch, useSelector } from "react-redux";
import { persistor, RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.user.info);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLogout = async () => {
        setShowLogoutModal(false);
        // 1. Clear redux state
        dispatch({ type: "RESET_APP" });
        // 2. Purge redux-persist storage
        await persistor.flush();
        await persistor.purge();
        // 3. Clear localStorage (optional but safe)
        localStorage.removeItem("access_token");
        localStorage.clear();
        // 4. Redirect to login page
        navigate("/login", { replace: true });
    };

    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar expand="lg">
                        <Navbar.Brand className="me-5">
                            <img src={saferstoplogo} width={72} height={72} alt='SaferStops' />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />

                        <div className="d-flex align-items-center ms-auto gap-3">

                            <div ref={dropdownRef} className="relative prodile-menu-btn z-[2000]">
                                <Button
                                    onClick={() => setDropdownOpen(!dropdownOpen)}
                                    className="flex items-center text-sm pe-1 mt-3 px-0 font-medium text-heading rounded-full hover:text-fg-brand md:me-0 focus:ring-4 focus:ring-neutral-tertiary"
                                    type="button"
                                >
                                    <span className="sr-only">Open user menu</span>
                                    <img
                                        src={user?.profile_pic || avtar}
                                        width={30}
                                        height={30}
                                        className="rounded-full h-10 w-10 flex bg-teal-400 m-2 object-fit-cover"
                                        alt=""
                                    />
                                    <span className="mr-2">{user?.name}</span>
                                    <MdOutlineKeyboardArrowDown size="20" />
                                </Button>

                                <div className={`absolute right-0 mt-7 z-50 ${dropdownOpen ? 'block' : 'hidden'} bg-neutral-primary-medium border border-default-medium rounded-base shadow-lg w-72`}>
                                    <ul className="px-2 pb-2 text-sm text-body font-medium" aria-labelledby="dropdownAvatarNameButton" style={{ background: '#FFF' }}>
                                        <li>
                                            <a href="/my-profile" className="inline-flex items-center w-full p-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                                                <svg className="w-4 h-4 me-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                                                My Profile
                                            </a>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => setShowLogoutModal(true)}
                                                className="inline-flex items-center w-full p-2 text-fg-danger hover:bg-neutral-tertiary-medium rounded"
                                            >
                                                <svg className="w-4 h-4 me-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" /></svg>
                                                Sign out
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {showLogoutModal && (
                                <div className="fixed inset-0 z-[3000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
                                    <div className="bg-white rounded-2xl shadow-xl w-[90%] max-w-md overflow-hidden">

                                        {/* Header */}
                                        <div className="px-6 py-4 bg-gradient-to-r from-red-500 to-red-600 text-white">
                                            <h2 className="text-lg font-semibold">
                                                Confirm Logout
                                            </h2>
                                        </div>

                                        {/* Body */}
                                        <div className="p-6">
                                            <p className="text-sm text-gray-600 mb-6">
                                                Are you sure you want to sign out of your account?
                                            </p>

                                            {/* Actions */}
                                            <div className="flex justify-end gap-3">
                                                <button
                                                    onClick={() => setShowLogoutModal(false)}
                                                    className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        handleLogout();
                                                    }}
                                                    className="px-5 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition shadow-sm"
                                                >
                                                    Yes, Logout
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Navbar>
                </Container>
            </header>
        </>
    )
}
export default Header;